import { Popover, TextField } from '@mui/material';
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import React from 'react';
import { mapToIsoOnlyDate } from '../../utils/date/mapToIsoOnlyDate';
import { DefaultDateFormat } from '../../utils/date/DefaultDateFormat';
import { DatePickerView } from '@mui/lab/DatePicker/shared';

interface IProps {
    anchor: HTMLElement | null;
    close: () => void;
    value: Date | undefined | null;
    setValue: (date: Date | null) => void;
    openTo?: DatePickerView;
    views?: DatePickerView[];
}

export const StaticDatePickerPopover = ({ anchor, close, value, setValue, openTo = "day", views = ["year", "month", "day"] }: IProps) => {
    return (
        <Popover
            anchorEl={anchor}
            open
            onClose={close}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted>
            <StaticDatePicker
                displayStaticWrapperAs="desktop"
                openTo={openTo}
                views={views}
                value={value === undefined ? null : value}
                onChange={(date) => {
                    setValue(mapToIsoOnlyDate(date))
                    close();
                }}
                inputFormat={DefaultDateFormat}
                renderInput={(props) => <TextField {...props} />} />
        </Popover>
    );
}